import store from '@/store';
import constants from '@/constants';
import axios from 'axios';
import { getAuthCookie } from '@/utils/cookie';
import { guidEqual, guidNormal } from '@/utils/guid.js';

let itemsCached = 0;
let cacheOfflineDataProgress = 0;

function offlineResponsePut(response) {
    let offlineResponses = [...store.getters.offlineResponses];
    var bFound = false;
    for (let index = 0; index < offlineResponses.length; ++index) {
        if (guidEqual(offlineResponses[index].tid, response.tid) &&
            offlineResponses[index].member_code === response.member_code) {
            bFound = true;
            offlineResponses[index] = response;
        }
    }
    // If not found (new offline response), then add it to the list of offline responses
    if (!bFound) {
        offlineResponses.push(response);
    }
    store.commit('SET_OFFLINE_RESPONSES', offlineResponses);
    store.commit('SET_OFFLINE_RESPONSES_STATUSES', offlineResponses);
}

function offlineUploadResponseStatus(offlineResponse) {
    let offlineResponses = [...store.getters.offlineResponses];
    let offlineResponseStatuses = [...store.getters.offlineResponseStatuses];
    let foundResponse;
    if(offlineResponse.status === 'failed') {
        foundResponse = offlineResponseStatuses.find(response => {
            return guidEqual(offlineResponse.data.rowid, response.rowid);
        });
    } else {
        foundResponse = offlineResponseStatuses.find(response => {
            return guidEqual(offlineResponse.data.datarow.TR_rowid, response.rowid);
        });
        offlineResponses = offlineResponses.filter(response => {
            return !guidEqual(offlineResponse.data.datarow.TR_rowid, response.rowid);
        });
    }
    foundResponse.status = offlineResponse.status;    
    store.commit('SET_OFFLINE_RESPONSES', offlineResponses);
    store.commit('SET_OFFLINE_RESPONSES_STATUSES', offlineResponseStatuses);
}

function offlineUploadImageStatus(offlineImage) {
    let offlineImages = [...store.getters.offlineImages];
    let offlineImageStatuses = [...store.getters.offlineImageStatuses];
    let foundImage;
    if(offlineImage.status === 'failed') {
        foundImage = offlineImageStatuses.find(image => {
            return guidEqual(offlineImage.data.rowid, image.rowid);
        });
    } else {
        foundImage = offlineImageStatuses.find(image => {
            return guidEqual(offlineImage.data.rowid, image.rowid);
        });
        offlineImages = offlineImages.filter(image => {
            return !guidEqual(offlineImage.data.rowid, image.rowid);
        });
    }
    foundImage.status = offlineImage.status;
    store.commit('SET_OFFLINE_IMAGES', offlineImages);
    store.commit('SET_OFFLINE_IMAGES_STATUSES', offlineImageStatuses);
}

function showUploadOfflineDialog(offlineImageCount) {
    let offlineResourceCount = store.getters.offlineResponses.length;
    offlineResourceCount += offlineImageCount;
    if(offlineResourceCount){
        store.commit('SET_SHOW_UPLOAD_OFFLINE_DIALOG', true);
    }
}
async function setOnlineStatus(event) {
    const offlineImageCount = await getOfflineImageCount();
    if(offlineImageCount === 0) {
        store.commit('SET_OFFLINE_IMAGES', []);
        store.commit('SET_OFFLINE_IMAGES_STATUSES', []);
    }
    if(!event.data.FORCED_OFFLINE){
        if(store.getters.forceOffline && getAuthCookie()) {
            showUploadOfflineDialog(offlineImageCount);
        }
        store.commit('SET_CACHING_OFFLINE_DATA', false);
    }
    store.commit('SET_FORCE_OFFLINE', event.data.FORCED_OFFLINE);
    if(event.data.offlineResponses) {
        store.commit('SET_OFFLINE_RESPONSES', event.data.offlineResponses);
        store.commit('SET_OFFLINE_RESPONSES_STATUSES', event.data.offlineResponses);
    }
}

function serviceWorkerRegistrationCallback() {
    navigator.serviceWorker.addEventListener('message', async function (event) {
        switch (event.data.message) {
            case 'online-status':
                await setOnlineStatus(event);
                break;
            case 'offline-progress':
                itemsCached++;
                cacheOfflineDataProgress = Math.floor((itemsCached/event.data.total) * 100);
                store.commit('SET_CACHING_OFFLINE_DATA_PROGRESS', cacheOfflineDataProgress);
                if(itemsCached === event.data.total){
                    setTimeout(() => {
                        store.commit('SET_CACHING_OFFLINE_DATA', false);
                    }, 1000);
                }
                break;
            case 'offline-response-put':
                offlineResponsePut(event.data.responseObject);
                break;
            case 'begin-post-offline-responses':
                store.commit('SET_OFFLINE_RESPONSES', event.data.offlineResponses);
                store.commit('SET_OFFLINE_RESPONSES_STATUSES', event.data.offlineResponses);
                if(event.data.offlineResponses?.length) {
                    store.commit('SET_SHOW_UPLOAD_OFFLINE_DIALOG', true);
                }
                break;
            case 'post-offline-response':
                // update Posting Offline Responses dialog
                offlineUploadResponseStatus(event.data);
                break;
            case 'end-post-offline-responses':
                console.log('end-post-offline-responses');
                break;
            case 'begin-post-all-offline-images':
                // show Posting Offline Images dialog
                store.commit('SET_OFFLINE_IMAGES', event.data.offlineImages);
                store.commit('SET_OFFLINE_IMAGES_STATUSES', event.data.offlineImages);
                console.log('begin-post-all-offline-images ', event.data.offlineImages);
                break;
            case 'post-all-offline-image':
                offlineUploadImageStatus(event.data);
                console.log('offline-image-posted ', event.data);
                break;
            case 'end-post-all-offline-images':
                console.log('end-post-offline-images');
                break;
            case 'offline-image-count':
                console.log('offline-image-count ', event.data.IMAGE_COUNT);
                break;
        }
    });

    if (navigator.serviceWorker.controller === null) {
        console.log('navigator.serviceWorker.controller is null,'
            + ' this can happen due to a hard refresh.'
            + ' Performing a "soft" refresh to initiallize navigator.serviceWorker.controller.');
        location.reload();
    } else {
        const appFilesToCache = getAppFileNamesToCache();
        navigator.serviceWorker.controller.postMessage({
            handlerName: 'initializeCaching',
            newtinDomain: constants.NEWTIN_DOMAIN || '',
            appFilesToCache,
        });

        navigator.serviceWorker.controller.postMessage({
            handlerName: 'getIsOffLineStatus'
        });
    }
}
function getAppFileNamesToCache() {
    let headLinks = document.querySelectorAll('head > link');
    let fileNamesToCache = [];
    for(let link of headLinks) {
        fileNamesToCache.push(link.href);
    }
    return fileNamesToCache;
}
async function loadAndRegisterServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('serviceWorker.js')
            .then(function () {
                console.log('loadAndRegisterServiceWorker succeeded');
                serviceWorkerRegistrationCallback();
            }).catch(console.error);
    }
}
function forceOffline() {
    // May need to check if we have internet connection
    // in order for serviceWorker to be able to cache data
    // proserve.PING.goOffline();
    var offlineMessage = {
        handlerName: 'goOffline',
        tickets: store.getters.userClipboard,
    };
    itemsCached = 0;
    cacheOfflineDataProgress = 0;
    store.commit('SET_CACHING_OFFLINE_DATA_PROGRESS', cacheOfflineDataProgress);
    navigator.serviceWorker.controller.postMessage(offlineMessage);
    store.commit('SET_CACHING_OFFLINE_DATA', true);
}

async function goOnline() {
    const onlineHandler = getAuthCookie() ? 'goOnline' : 'goOnlineNoAuth';
    var onlineMessage = {
        handlerName: onlineHandler,
    };
    navigator.serviceWorker.controller.postMessage(onlineMessage);
    await getOfflineImageCount();
}
async function getOfflineImageCount() {
    let result = await axios.get(
        `/service-worker/offline-image-count`
    );
    if(result.data) {
        store.commit('SET_OFFLINE_IMAGE_COUNT', result.data.count);
        return result.data.count;
    }
    return 0;
}
async function getOfflineImage(rowid) {
    let result = await axios.get(
        `/service-worker/offline-image-data?rowid=${encodeURIComponent(guidNormal(rowid))}`
    );
    if(result.data) {
        return result.data;
    }
}
function postAllOfflineImages() {
    var postAllOfflineImagesMessage = {
        handlerName: 'postAllOfflineImages',
    };
    navigator.serviceWorker.controller.postMessage(postAllOfflineImagesMessage);
}

export default {
    loadAndRegisterServiceWorker,
    forceOffline,
    goOnline,
    postAllOfflineImages,
    getOfflineImage,
};